import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const topListApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/toplists/`, {params: params})
  },
  detail (topListId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/topswipes/${topListId}/`, {params: params})
  }
}

export default topListApi
